import React, { useState, useEffect } from 'react'
import Link from 'next/link'
import { useTrans } from 'hooks'
import { useSelector } from 'react-redux'
import { Close, Logo, Menu, Profile } from 'components/atoms/Icons'
import { BrandButton, Button, WContainer, WImage } from 'components/atoms'
import { Nav, NavMobile, TopMenu, SearchBar, SearchResultsDropdown } from 'components/organisms'
import useUtente from '@hooks/useUtente'
import styles from './HeaderLanding.module.sass'

interface Props {
  className?: string
  logoUrl?: string
  logoAlt?: string
}



const HeaderLanding = (props: Props) => {
  const { className = '', logoUrl, logoAlt } = props

  const t = useTrans()
  return (
    <header className={`${styles.header} ${className}`}>
      <div className={styles.main}>
        <div className={styles.mainContent}>
         
            
              <Link legacyBehavior href="/">
                <a className={styles.logoWrap}>
                  <div className={styles.logo}>
                    {logoUrl ? (
                      <WImage
                        src={logoUrl}
                        alt={logoAlt || 'Logo'}
                        title={logoAlt || 'Logo'}
                        maxWidth={146}
                        maxHeight={70}
                        className={styles.logoImage}
                      />
                    ) : (
                      <Logo className={styles.logoDesktop} />
                    )}
                  </div>
                </a>
              </Link>
        

        </div>
      </div>
 
    </header>
  )
}

export default HeaderLanding
